import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'channels',
  urlRoot: '/channels'
})
